<div class="voxel-col-12">
    <div class="voxel-col-12">
        <b class="voxel-text-body-01-bold">{{requiredDoc?config?.requireLabel:config?.label}}</b>
    </div>
    <div class="voxel-col-12">
        <em [textContent]="this.caption_files"></em>
    </div>
</div>
<div class="voxel-col-6">
    <div class="voxel-col-1">
        <button voxelButtonContextual buttonStyle="secondary" (click)="fileUpload.click(); fileChargeEvent();" [disabled]="isLoadingFiles" [buttonLoad]="isLoadingFiles"
            style="justify-content: center" loadingCircleContrast="white">Cargar archivos
        </button>
        <input #fileUpload type="file" [accept]="typeAccept() | async" excludeAcceptAllOption="true"
            style="visibility:hidden" multiple="true" id="" class="voxel-button voxel-button--secondary"
            (change)="loadFiles($event)" id="files" [required]="requiredDoc">
    </div>
    <div class="voxel-col-4" *ngIf="fileError">
        <span class="voxel-stamp voxel-stamp--error" [textContent]="fileError"></span>
    </div>
</div>
<div class="voxel-col-12">
    <span >{{config?.caption_count | stringFormat:[fileList?.length]}}</span>
    <voxel-list class="voxel-pb-8" *ngIf="fileList?.value?.length > 0">
        <li voxelListColumn *ngFor="let fileItem of fileList?.value || []; let i = index;">
            <voxel-list-text>
                <button voxelButtonAction (click)="downloadFile(fileItem?.file)">
                    {{fileItem?.file?.name}}
                </button>
            </voxel-list-text>
            <voxel-list-descr><em>{{fileItem.file.size|fileSize}}</em>
            </voxel-list-descr>
            <voxel-list-detail>
                <voxel-icon size="M" class="voxel-col-2" type="secondary" (click)="removeFile(i)">
                    {{config?.delete_icon}}</voxel-icon>
            </voxel-list-detail>
        </li>
    </voxel-list>
</div>
